import Learning from '../../assets/htbd-images/Layer.png';
import BackroundGradient from './common/BackroundGradient.component';

function YourLearning() {
  return (
      <section
        className="container-fluid p-5 position-relative"
      >
      <BackroundGradient />
        <div className="row justify-content-md-center">
          <div className="col-lg-4">
            <img
              src={Learning}
              className="img-fluid"
              style={{ height: '100%'}}
            />
          </div>
          <div className="col-lg-6">
            <div className="p-3 text-white">
              <h1>
                Your <strong style={{ color: "#7e56d8" }}>Learning</strong>
              </h1>
              <p>
                The LMS system will host all the material related to learning
                and assessments, more information on the LMS is available under
                the evaluation section of this document.
              </p>
              <p>
                The learning activities and instructional strategies will be in
                form of asynchronous resources and online group discussions.
                Pre-recorded videos, audio and written transcripts will be
                provided to access the material to gain the knowledge and
                develop an understanding going through lessons.
              </p>
              <p>
                In the sessions, you will find business professionals taking
                sessions on different topics and sharing their life experiences.
                The sessions will also include lectures on Dubai infrastructure
                with live pictures and vlogs giving you precise information to
                validate your real-time learning.
              </p>
              <p>
                The final learning and instructional lecture will be a live
                session to host (IBP) international business project more
                details on IBP will follow in this document.
              </p>
            </div>
          </div>
        </div>
      </section>
  );
}

export default YourLearning;
